import { jsx } from "react/jsx-runtime";
import { SellerAddressSearch } from "@zillow/zrs-cms";
const SELLER_ADDRESS_SEARCH_CONFIG_VALUES = {
  test: {
    origin: "https://www.qa.zillow.net",
    graphURL: "https://www.qa.zillow.net/graphql/"
  },
  prod: {
    origin: "https://www.zillow.com",
    graphURL: "https://www.zillow.com/graphql/"
  }
};
const isConfiguredEnvironment = (env) => env !== void 0 && Object.prototype.hasOwnProperty.call(SELLER_ADDRESS_SEARCH_CONFIG_VALUES, env);
const BlockSellerAddressSearch = ({
  attrs = {}
}) => {
  const NEXT_PUBLIC_ENV = process.env.NEXT_PUBLIC_ENV;
  return /* @__PURE__ */ jsx(SellerAddressSearch, { propertySearchConfigValues: isConfiguredEnvironment(NEXT_PUBLIC_ENV) ? SELLER_ADDRESS_SEARCH_CONFIG_VALUES[NEXT_PUBLIC_ENV] : SELLER_ADDRESS_SEARCH_CONFIG_VALUES.test, ...attrs });
};
export {
  SELLER_ADDRESS_SEARCH_CONFIG_VALUES,
  BlockSellerAddressSearch as default
};
